import { Component, Element, Fragment, Host, Listen, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-carousel-container',
  styleUrl: 'carousel-container.css',
  shadow: true,
})

export class CarouselContainer {
  @Element() host : HTMLElement;

  @Prop() height       : string  = 'auto';
  @Prop() maxWidth     : string  = 'initial';
  @Prop() showArrows   : boolean = true;
  @Prop() showDots     : boolean = true;
  @Prop() insideArrows : boolean = false;
  @Prop() insideDots   : boolean = false;
  @Prop() autoplay     : boolean = false;
  @Prop() interval     : number  = 3000;

  @State() slidesContainer : HTMLElement = null;
  @State() numChildren     : number = 0;
  @State() currentPage     : number = 1;
  @State() paginations     : any[];
  @State() ready           : boolean = false;
  @State() autoplayInterval: any;

  prev = () => {
    this.currentPage--;
    this.gotoPage();
    this.updatePaginations();
  }

  next = () => {
    this.currentPage++;
    this.gotoPage();
    this.updatePaginations();
  }

  slidesContainerTransitionEnd = () => {
    let multiplier = this.numChildren * 100;
    if (this.currentPage == 0 || this.currentPage > this.numChildren) {
      this.slidesContainer.style.transition = '0ms';

      if (this.currentPage > this.numChildren) {
        this.slidesContainer.style.transform = `translateX(-100%)`;
        this.currentPage = 1;

      } else if (this.currentPage == 0) {
        this.slidesContainer.style.transform = `translateX(-${multiplier}%)`;
        this.currentPage = this.numChildren
      }

      let timeout = setTimeout(() => {
        this.slidesContainer.style.transition = `transform 300ms ease-in-out`
        clearTimeout(timeout);
      }, 300);
    }
  }

  gotoPage = () => {
    this.slidesContainer.style.transform = `translateX(calc(${(this.currentPage) * (-100)}%))`;
  }

  updatePaginations = () => {
    const paginations = Array.from(this.host.shadowRoot.querySelectorAll('.pagination > li'));
    [...paginations].forEach(pagination => pagination.classList.remove('active'));
    if (this.currentPage > this.numChildren) {
      paginations[0].classList.add('active');
    } else if (this.currentPage < 1) {
      paginations[this.numChildren - 1].classList.add('active');
    } else {
      paginations[this.currentPage - 1].classList.add('active');
    }
  }

  checkIfReady = async ():Promise<void> => {
    return new Promise(resolve => {
      let checkIfReadyInterval = setInterval(() => {
        if (this.ready) {
          clearInterval(checkIfReadyInterval);
          resolve()
        };
      }, 100);
    })
  }

  startAutoPlay = () => {
    this.autoplayInterval = setInterval(() => {
      this.next();
    }, this.interval);
  }

  handleSlotChange = () => {
    this.slidesContainer = this.host.shadowRoot.querySelector('slot');
    this.slidesContainer.addEventListener('transitionend', this.slidesContainerTransitionEnd, false);

    if (!this.ready) {
      this.numChildren = Array.from(this.host.children).length;
      let paginationsTemp = [];

      if (this.numChildren >= 1) {
        for (let index = 0; index < this.numChildren; index++) {
          if (index == 0) {
            paginationsTemp.push(<li class="active" data-page-number="1"></li>);
          } else {
            paginationsTemp.push(<li data-page-number={`${index+1}`}></li>);
          }

          if (index == (paginationsTemp.length - 1)) {
            this.paginations = paginationsTemp;
          }
        }
      }

      let firstSlideClone = this.host.firstElementChild.cloneNode(true);
      let lastSlideClone = this.host.lastElementChild.cloneNode(true);
      this.host.append(firstSlideClone);
      this.host.prepend(lastSlideClone);

      this.ready = true;

      if (this.autoplay) {
        this.checkIfReady()
          .then(() => {
            this.startAutoPlay();
          });
      }
    }
  }

  @Listen('click')
  handleClick(e: { composedPath: () => any[]; }) {
    let el = e.composedPath()[0];
    if (el.parentNode.classList && el.parentNode.classList.contains('pagination')) {
      this.currentPage = parseInt(e.composedPath()[0].dataset.pageNumber);
      this.gotoPage();
      [...el.parentNode.children].forEach(child => child.classList.remove('active'));
      el.classList.add('active');
    }

    if (el.classList.contains('carousel-prev') || el.classList.contains('carousel-next')) {
      this.updatePaginations();
    }
  }

  @Listen('mouseover')
  handleMouseOver() {
    clearInterval(this.autoplayInterval);
  }

  @Listen('mouseout')
  handleMouseOut() {
    if (this.autoplay) {
      this.startAutoPlay();
    }
  }

  render() {
    return (
      <Host
        style={{
          maxWidth: `${this.maxWidth}`
        }}
      >
        <div
          class={`content-wrapper ${!this.showArrows && 'no-arrows'} ${!this.showDots && 'no-dots'} ${this.insideArrows && 'inside-arrows'}`}
          style={{
            height:`${this.height}`,
          }}
        >
          <slot onSlotchange={this.handleSlotChange}></slot>
        </div>
        {this.showArrows && (this.numChildren > 1) && <Fragment>
          <div class="arrow arrow-left carousel-prev" onClick={this.prev}>
            <img src="https://img.cradlepoint.com/auto-mapping-folder/2020/06/left-arrow.webp"/>
          </div>
          <div class="arrow arrow-right carousel-next" onClick={this.next}>
            <img src="https://img.cradlepoint.com/auto-mapping-folder/2020/06/right-arrow.webp"/>
          </div>
        </Fragment>}
        {this.showDots && (this.numChildren > 1) && this.paginations &&
          <ul
            class={`pagination ${this.insideDots && 'inside-dots'}`}
          >
            {this.paginations}
          </ul>
        }
      </Host>
    );
  }

}
